module.exports = __webpack_public_path__ + "img/00 banner.3f7814bd.png";